import React from 'react'
import { VideoType, getVideoTypeGuides, GuideItem } from 'constant/videoTypes'

interface VideoGuideListProps {
  videoType: VideoType
}

export const VideoGuideList = ({ videoType }: VideoGuideListProps) => {
  const guides = getVideoTypeGuides(videoType)

  if (!guides.length) return null

  return (
    <ul className="list-disc pl-8 text-left mt-4">
      {guides.map((guide: GuideItem, index: number) => (
        <li key={index} className="p-[4px]">
          {guide.type === 'link' ? (
            <a
              href={guide.href}
              target="_blank"
              rel="noreferrer"
              className="text-href font-bold underline"
            >
              {guide.text}
            </a>
          ) : (
            <span>{guide.text}</span>
          )}
        </li>
      ))}
    </ul>
  )
}
